import React, { useEffect, useState } from 'react'
import { useHistory, useParams, withRouter } from 'react-router-dom'
import { routes } from '../../../../constantes/routes'
import ContactDetailComponent from '../../contacts/contact-detail/ContactDetailComponent'
import ContactHospitalsListComponent from './ContactHospitalsListComponent'
import '../../../../assests/styles/contatcs/ContactDetail.scss'
import Header from '../../../header/Header'
import { useSelector } from 'react-redux'
import ContactNoteDetail from './ContactNoteDetail'

const ContactAndTheirHospitalsDetailContainer = () => {
  let { id } = useParams()
  const history = useHistory()
  const hospitalsContacts = useSelector((state) => state.hospitalsContacts)

  const [details, setDetails] = useState({})

  useEffect(() => {
    getInfoContactAndTheirHospitals(id)
  }, [id])

  const getInfoContactAndTheirHospitals = async (idContact) => {
    try {
      const item = hospitalsContacts.find(
        (x) => x.id_Contacto.toString() === idContact,
      )
      setDetails(item)
    } catch (error) {
      toContacts()
    }
  }

  const toContacts = () => {
    history.push(routes.CONTACTS)
  }

  return (
    <>
      {
        <div className='products'>
          <Header
            text={'Detalles del contacto'}
            route={toContacts}
            backBtn={false}
          />
          <ContactDetailComponent details={details} isEdit={false} />
          <ContactHospitalsListComponent
            hospitalsContact={details.hospitalsContacts}
          />
          <ContactNoteDetail canEdit={false} />
        </div>
      }
    </>
  )
}

export default withRouter(ContactAndTheirHospitalsDetailContainer)
